import { useContext } from 'react'
import UserContext from '../contexts/user'

const useIsAuthenticated = (): boolean => {
  const { user } = useContext(UserContext)

  return !(user == null)
}

export default useIsAuthenticated;
